export default __webpack_public_path__ + "static/media/why-we-started.60053bd4.webp";